export default __webpack_public_path__ + "static/media/green_arrow.a52dfb51.svg";